import Cookies from 'js-cookie';
export class Geo {
  cookie = false;
  domain = location.host.includes('schoffelcountry.com') ? '.schoffelcountry.com' : location.host;

  /**
   * Set a cookie with the user's country code preference and store for 30 days
   * @param {string} country - Country object with "handle" and "name" keys
   */
  setGeolocationCookie(country) {
    Cookies.set('geolocation', JSON.stringify(country), {
      expires: 30,
      domain: this.domain
    });
  }

  /**
   * Fetch the user's stored country code (if present)
   * @returns {string} Country object with "handle" and "name" keys
   */
  getGeolocationCookie() {
    try {
      return JSON.parse(Cookies.get('geolocation'));
    } catch (e) {
      return false;
    }
  }

  /**
   * Fetch Shopify's location recommendations, then set a cookie and execute callback
   * @async
   * @param {Function} callback - Optional callback
   */
  async getLocation(callback = false) {
    fetch(Shopify.routes.root + 'browsing_context_suggestions.json').then(response => response.json()).then(json => {
      this.setGeolocationCookie(json.detected_values.country);
      if (callback) callback(json.detected_values.country);
    }).catch(error => {
      console.warn(error);
    });
  }

  /**
   * Check for an existing cookie, otherwise detect user's country
   * @param {Function} callback - Optional callback 
   */
  perform(callback = false) {
    this.cookie = this.getGeolocationCookie();
    if (this.cookie && this.cookie.hasOwnProperty('handle')) {
      if (callback) callback(this.cookie);
    } else {
      this.getLocation(callback);
    }
  }

  /**
   * Setup global object so we can access the class anywhere
   * @constructor
   */
  constructor() {
    window.Geo = this;
  }
}